import { _baseClient } from '../index';
import { withPagination } from '../pagination';

export const activityTypeList = (pageSize, pageNumber, query = {}) => {
  return withPagination(
    (state) =>
      _baseClient.get('/activity-type/list', {
        pageSize: state.pageSize,
        pageNumber: state.pageNumber,
        ...query,
      }),
    { pageSize, pageNumber },
  );
};
export const activityTypeAdd = (params) => {
  return _baseClient.post('/activity-type/save', { body: params }).then((response) => {
    return response;
  });
};

export const activityTypeDelete = (params) => {
  return _baseClient.get('/activity-type/delete', params);
};

export const activityTypeDetail = (params) => {
  return _baseClient.get('/activity-type/get', params);
};

export const activityTypeUpdateStatus = (params) => {
  return _baseClient.get('/activity-type/update-status', params);
};

export const getactivityTypes = (params) => {
  return _baseClient.post('/activity-type/get-activity-types', { body: params });
};
